<template>
  <div v-if="!isMobile()">
    <div
      class="section section-areanainvestor"
      id="areanainvestor-section"
      data-background-color="white"
    >
      <div class="container text-center">
        <h3 data-aos="fade-up" class="title deco1">LOKA AVAILABLE ON</h3>
        <div class="row" style="padding-top: 20px">
          <div
            class="box-links text-center"
            v-for="(link, index) in links"
            v-bind:key="index"
          >
            <a v-bind:href="link.url" target="_blank">
              <img
                v-bind:src="`/img/links/${link.img}`"
                v-bind:width="link.width"
                v-bind:style="link.style"
              />
            </a>
          </div>
        </div>
        <h3 data-aos="fade-up" class="title deco1" style="margin-top: 80px;">{{ $t(`INVESTORS`) }}</h3>
        <div class="row" style="padding-top: 20px">
          <div
            class="box-investor text-center"
            v-for="(investor, index) in investors"
            v-bind:key="index"
          >
            <a v-bind:href="investor.url" target="_blank">
              <img
                v-bind:src="`/img/investors/${investor.img}`"
                v-bind:width="investor.width"
                v-bind:style="investor.style"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div
      class="section-m section-partners"
      id="partners-section"
      data-background-color="white"
    >
      <div class="container text-center">
        <h3 class="title-m deco1">LOKA AVAILABLE ON</h3>
        <div class="row" style="width: 85%; margin: auto;">
          <div
            class="box-links-m text-center"
            v-for="(link, index) in links"
            v-bind:key="index"
          >
            <a v-bind:href="link.url" target="_blank">
              <img
                v-bind:src="`/img/links/${link.img}`"
                height="100%"
                style="object-fit: contain; padding-top: 0px;"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="container text-center" style="margin-top: 40px;">
        <h3 class="title-m deco1">{{ $t(`INVESTORS`) }}</h3>
        <div class="row" style="width: 85%; margin: auto;">
          <div
            class="box-partner-m text-center"
            v-for="(investor, index) in investors"
            v-bind:key="index"
          >
            <a v-bind:href="investor.url" target="_blank">
              <img
                v-bind:src="`/img/investors/${investor.img}`"
                height="100%"
                style="object-fit: contain; padding-top: 0px;"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  data: function () {
    return {
      links: [
        {
          url: "https://www.binance.com/en/trade/LOKA_USDT?ref=AZXYVL5Z",
          img: "link_binance.png",
          width: "100%",
          style: {}
        },
        {
          url: "https://www.huobi.com/en-us/exchange/loka_usdt",
          img: "link_huobi.png",
          width: "100%",
          style: {}
        },
        {
          url: "https://www.kucoin.com/trade/LOKA-USDT",
          img: "link_kucoin.png",
          width: "100%",
          style: {}
        },
        {
          url: "https://www.gate.io/trade/LOKA_USDT",
          img: "link_gateio.png",
          width: "100%",
          style: {}
        },
        {
          url: "https://crypto.com/exchange/trade/spot/LOKA_USDT",
          img: "link_crypto.png",
          width: "100%",
          style: {}
        },
      ],
      investors: [
        {
          url: "https://www.hashed.com/",
          width: "100%",
          style: {},
          img: "partner_01.png",
        },
        {
          url: "https://a16z.com/crypto/",
          width: "100%",
          style: {},
          img: "partner_02.png",
        },
        {
          url: "https://india.sequoiacap.com/",
          width: "100%",
          style: {},
          img: "partner_03.png",
        },
        {
          url: "https://labs.binance.com/",
          width: "100%",
          style: {},
          img: "partner_04.png",
        },
        {
          url: "https://www.blocktower.com/",
          width: "100%",
          style: {},
          img: "partner_05.png",
        },
        {
          url: "https://yieldguild.io/",
          width: "100%",
          style: {},
          img: "partner_06.png",
        },
        {
          url: "https://www.skyvisioncapital.com/",
          width: "100%",
          style: {},
          img: "partner_07.png",
        },
        {
          url: "https://despread.io/",
          width: "100%",
          style: {},
          img: "partner_08.png",
        },
        {
          url: "https://trinito.co/",
          width: "100%",
          style: {},
          img: "partner_09.png",
        }
      ],
    };
  },
};
</script>
<style></style>
